<template>
  <div data-v-db2fc762="" data-v-2ac6a5fc="" class="accountCenter">
    <div data-v-db2fc762="" class="row">
      <h4 data-v-db2fc762="">基础信息设置</h4>
      <div data-v-db2fc762="" class="list">
        <div data-v-db2fc762="" class="item">
          <p data-v-db2fc762="">真实姓名 {{ $store.state.userInfo.realname }}</p>
        </div>
        <div data-v-db2fc762="" class="item">
          <p data-v-db2fc762="">登录密码</p>
          <a data-v-db2fc762="" @click="$parent.goNav('/resetPasswordNew')">修改</a><i data-v-db2fc762="" class="arrow"></i>
        </div>
        <div data-v-db2fc762="" class="item">
          <p data-v-db2fc762="">手机号码 {{ $store.state.userInfo.mobile }}</p>
          <a data-v-db2fc762="" @click="$parent.goNav('/modifyPhone')">{{ $store.state.userInfo.mobile ? '绑定' : '未绑定' }}</a
          ><i data-v-db2fc762="" class="arrow"></i>
        </div>
        <div data-v-db2fc762="" class="item">
          <p data-v-db2fc762="">电子邮箱 {{ $store.state.userInfo.email }}</p>
          <a data-v-db2fc762="" @click="$parent.goNav('/modifyEmail')">{{ $store.state.userInfo.email ? '修改' : '未绑定' }}</a
          ><i data-v-db2fc762="" class="arrow"></i>
        </div>
      </div>
    </div>
    <div data-v-db2fc762="" class="row">
      <h4 data-v-db2fc762="">取款交易设置 <i data-v-db2fc762=""></i> <span data-v-db2fc762="">进行取款操作需完成以下操作</span></h4>
      <div data-v-db2fc762="" class="list">
        <a @click="$parent.goNav('/bankCard')"
          ><div data-v-db2fc762="" class="item">
            <p data-v-db2fc762="">银行卡管理</p>
            <i data-v-db2fc762="" class="arrow"></i></div
        ></a>
        <div data-v-db2fc762="" class="item">
          <p data-v-db2fc762="">资金密码</p>
          <a data-v-db2fc762="" @click="$parent.goNav('/modifyPayPassword')">修改</a><i data-v-db2fc762="" class="arrow"></i>
        </div>
      </div>
    </div>
    <div data-v-db2fc762="" class="row">
      <h4 data-v-db2fc762="">代理及活动 <i data-v-db2fc762=""></i> <span data-v-db2fc762=""></span></h4>
      <div data-v-db2fc762="" class="list">
        <a @click="$parent.goNav('/activeList')"
          ><div data-v-db2fc762="" class="item">
            <p data-v-db2fc762="">活动列表</p>
            <i data-v-db2fc762="" class="arrow"></i></div
        ></a>
        <a @click="$parent.goNav('/applyagentList')"
          ><div data-v-db2fc762="" class="item">
            <p data-v-db2fc762="">活动申请记录</p>
            <i data-v-db2fc762="" class="arrow"></i></div
        ></a>
        <a @click="$parent.goNav('/applyagent')" v-if="$store.state.userInfo.isagent == 0"
          ><div data-v-db2fc762="" class="item">
            <p data-v-db2fc762="">申请代理</p>
            <i data-v-db2fc762="" class="arrow"></i></div
        ></a>
           <a  @click="getAgentLoginUrl" v-if="$store.state.userInfo.isagent == 1"
          ><div data-v-db2fc762="" class="item">
            <p data-v-db2fc762="">代理登录</p>
            <i data-v-db2fc762="" class="arrow"></i></div
        ></a>
 
      </div>
    </div>
>
  </div>
</template>
<script>
export default {
  name: 'accountCenter',
  data() {
    return {};
  },
  created() {
    let that = this;
  },
  methods: {},
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-4db6e37b.7ed2c07b.css';
.footerWrap[data-v-64785503] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/main/accountCenter.vue